import Header from './Header'
import HeaderDropdown from './HeaderDropdown'

export {
  Header,
  HeaderDropdown
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/vue/src/components/Header/index.js
// module id = ZUU3
// module chunks = 0